<template>
  <div>
    <div
      class="row justify-content-center align-items-center mw-home-container"
    >
      <div class="container">
        <div
          v-for="(line, index) in getChunkedCardsList"
          :key="index"
          class="row justify-content-center"
        >
          <MaydayWebHomeCard
            v-for="card in line"
            :key="`${card.id}-${navigationLanguage}`"
            v-bind="card"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaydayWebHomeCard from './Home/MaydayWebHomeCard';
import emojiStrip from '@/utils/emojiStrip';

import { mapGetters } from 'vuex';

export default {
  name: 'MaydayWebHome',
  components: {
    MaydayWebHomeCard,
  },
  computed: {
    ...mapGetters(['isSplitKnowledgeViewer']),
    ...mapGetters('webKnowledgeModule', [
      'focusKnowledgeRoots',
      'navigationLanguage',
    ]),
    orderedKnowledgeRoots() {
      if (!this.focusKnowledgeRoots) return [];
      if (!this.isSplitKnowledgeViewer) return this.focusKnowledgeRoots;
      return [...this.focusKnowledgeRoots].sort((a, b) =>
        emojiStrip(a.label).localeCompare(emojiStrip(b.label)),
      );
    },
    getChunkedCardsList() {
      const nb = this.orderedKnowledgeRoots.length === 4 ? 2 : 3;
      let chunked = [];
      let cardsTmp = [...this.orderedKnowledgeRoots];

      while (cardsTmp.length > 0) {
        chunked.push(cardsTmp.splice(0, nb));
      }

      return chunked;
    },
  },
};
</script>

<style lang="scss" scoped>
.mw-home-container {
  height: calc(100vh - 360px);
}
</style>
